import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'shpmtcd'

const info = (isValid, validationMessages) => {
  if (isValid) {
    return (
      <div className='info'>
        {validationMessages.toString()}
      </div>
    )
  }
  return null
}

const indicator = (isValid) => {
  if (isValid) {
    return <span className='indicator ico-available' />
  }
  return <span className='indicator ico-close-thin' />
}

const EmailField = ({
  labelText, placeholder, value, isValid, validationMessages, showIndicator,
  onEmailChange,
}) => (
  <div className='email-field'>
    <Input
      label={labelText}
      placeholder={placeholder}
      value={value}
      error={isValid ? '' : validationMessages.toString()}
      onChange={onEmailChange}
      required
    />
    {showIndicator ? indicator(isValid) : null}
    {info(isValid, validationMessages)}
  </div>
)

EmailField.propTypes = {
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  validationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  showIndicator: PropTypes.bool,
  onEmailChange: PropTypes.func.isRequired,
}

EmailField.defaultProps = {
  labelText: 'Email address',
  placeholder: '',
  showIndicator: false,
}

export default EmailField
